$(document).ready(function() {

  $('.newsletter-link').magnificPopup({
    type:'inline',
    midClick: true,
    mainClass: 'mfp-fade mfp-fade-newsletter',
    closeOnBgClick: true,
    closeBtnInside: true,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    removalDelay: 100
  });



  var dialogShown = localStorage.getItem('dialogShown')

  if (!dialogShown) {
    $(window).load(function(){
      $('.newsletter-link').magnificPopup({
        type:'inline',
        midClick: true,
        mainClass: 'mfp-fade mfp-fade-newsletter',
        closeOnBgClick: true,
        closeBtnInside: true,
        closeOnContentClick: false,
        tClose: theme.strings.zoomClose,
        removalDelay: 100
      });
      localStorage.setItem('dialogShown', 1)
    });
  }

  function myTimer() {
    $(".gift-wrap-cart-checkbox").click(function() {
      if($(this).children('input').is(":checked")) {
        $(".gift-wrap-cart-notes").show();
      } else {
        $(".gift-wrap-cart-notes").hide();
      }
    });
    if ($('.gift-wrap-cart-checkbox').prop('checked')) {
      $(".gift-wrap-cart-notes").show();
    }
    if ($('.gift-wrap-cart-checkbox #gift-wrap-cart-checkbox').prop('checked')) {
      $(".gift-wrap-cart-notes").show();
    } else {
      $(".gift-wrap-cart-notes textarea").val('');
    }
  }

  var myVar = setInterval(myTimer, 100);

});

// Navigation static

var startProductBarPos=-1;
window.onscroll=function(){
  var bar = document.getElementById('nav_bar');
  var mega_bar = document.getElementById('nav_megamenu_bar');

  if(bar){
    if(startProductBarPos<0)startProductBarPos=findPosY(bar);
    if(pageYOffset>startProductBarPos){
      // bar.style.position='fixed';
      // bar.style.top=0;
    }else{
      bar.style.position='relative';
    }
  }
  if (mega_bar) {
    if(startProductBarPos<0)startProductBarPos=findPosY(mega_bar);
    if(pageYOffset>startProductBarPos){
      // mega_bar.style.position='fixed';
      // mega_bar.style.top=0;
    }else{
      mega_bar.style.position='relative';
    }
  }
};

function findPosY(obj) {
  var curtop = 0;
  if (typeof (obj.offsetParent) != 'undefined' && obj.offsetParent) {
    while (obj.offsetParent) {
      curtop += obj.offsetTop;
      obj = obj.offsetParent;
    }
    curtop += obj.offsetTop;
  }
  else if (obj.y)
    curtop += obj.y;
  return curtop;
}


// touch effect
// if (window.innerWidth > 768) {
//   const links = document.querySelectorAll('#nav_megamenu_bar .site-nav__link');

//   links.forEach(link => {
//     link.addEventListener('click', (e) => {
//       // Ignore touch events (like tap)
//       if (e.pointerType === 'touch') return;

//       e.stopPropagation();
//       links.forEach(l => l.classList.remove('mega_active'));
//       link.classList.add('mega_active');
//     });
//   });

//   document.addEventListener('click', (e) => {
//     if (e.pointerType === 'touch') return;

//     const navBar = document.getElementById('nav_megamenu_bar');
//     if (!navBar.contains(e.target)) {
//       links.forEach(link => link.classList.remove('mega_active'));
//     }
//   });
// }


/*** SEARCH FUNCTIONALITY START ***/ 
if(window.innerWidth > 766){
  const search_toggle = document.querySelectorAll(".js-toggle-search-modal");

  if(search_toggle.length > 0){
    search_toggle.forEach(element => {
      element.addEventListener("click", () => {
        let attempts = 0;
        const maxAttempts = 200; // stop after 20 intervals (~6 seconds)

        const intervalId = setInterval(() => {

          const search_view = document.querySelector(".mfp-wrap.mfp-ready");
          const close_button = document.querySelector(".mfp-wrap .mfp-close");
          if (search_view) {
            search_view.style.transform = 'translateY(0%)';
            if(close_button){
              close_button.addEventListener("click", () => {
                search_view.style.transform = 'translateY(-100%)';
              })
            }
            clearInterval(intervalId); // stop when found
            return;
          }

          // stop interval if not found after X attempts
          attempts++;
          if (attempts >= maxAttempts) {
            console.warn("search_view not found — stopping interval");
            clearInterval(intervalId);
          }

        }, 300);  
      })
    });
  }
}
/*** SEARCH FUNCTIONALITY END ***/ 


/*** MEGA MENU FUNCTIONALITY START ***/
if(window.innerWidth > 766){
  const mega_nav__layout = document.querySelectorAll('.navigation.nav--mega-menu');
  if(mega_nav__layout.length > 0){
    document.addEventListener('DOMContentLoaded', () => {
      const site__mega_menu = document.querySelector('.mega-menu--layout.site-nav__mega-menu');
      const tabs = document.querySelectorAll('.mega-tab');
      const panels = document.querySelectorAll('.mega-panel');
      // Sub SUb SUb Menu tab
      const el_shop = document.querySelector('.navigation.nav--mega-menu .shop-by-designer');
      const mega_subSub__menu = document.querySelectorAll('.navigation.nav--mega-menu .mega-sub-menu--list-item');
      const mega_subSub__columns = document.querySelectorAll('.navigation.nav--mega-menu .mega-panel .mega-columns');
      const mega_SubMenu = document.querySelector(".nav--mega-menu .mega-menu-child--title");
      
      // Save initial active elements
      const initialTab = document.querySelector('.mega-tab.active');
      const initialPanel = document.querySelector('.mega-panel.active');

      // Desktop: hover
      el_shop.addEventListener('mouseenter', function (e) {
          tabs.forEach((t) => t.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));

          el_shop.classList.add('is-open');
          mega_subSub__menu[0].classList.add('inner-tab--active');

          document
            .getElementById(this.dataset.target)
            .classList.add('active');
        });

      tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => {
          tabs.forEach((t) => t.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));
          mega_subSub__menu.forEach((t) => t.classList.remove('inner-tab--active'));

          tab.classList.add('active');
          document.getElementById(tab.dataset.target).classList.add('active');
        });
      });

      mega_subSub__menu.forEach((sub_tab) => {
        sub_tab.addEventListener('mouseenter', () => {
          mega_subSub__menu.forEach((t) => t.classList.remove('inner-tab--active'));
          mega_subSub__columns.forEach((ms) => ms.classList.remove('mega-column--active'));

          sub_tab.classList.add('inner-tab--active');
          document.getElementById(sub_tab.dataset.target).classList.add('mega-column--active');
        });
      });

      // Reset when leaving the menu
      site__mega_menu.addEventListener('mouseleave', () => {
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        mega_subSub__menu.forEach((t) => t.classList.remove('inner-tab--active'));
        el_shop.classList.remove('is-open');

        if (initialTab) initialTab.classList.add('active');
        if (initialPanel) initialPanel.classList.add('active');
      });

    });
  }
  const search_button_icon = document.querySelector('.search_button_icon');
  if(search_button_icon){
    const header__top_links  = document.querySelector('.header--top-links');
    search_button_icon.addEventListener('click', (e) => {
        header__top_links.classList.add("show_hide__btn");
    })
  }
}
/*** MEGA MENU FUNCTIONALITY END ***/


/*** CART COUNT UPDATE START ***/
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(({ item_count }) => {
      const bubbles = [
        document.getElementById('cart-count-bubble'),
        document.getElementById('cart-count-bubble--mobile')
      ];

      bubbles.forEach(bubble => {
        if (bubble) bubble.textContent = item_count;
      });
    })
    .catch(err => console.error('Cart fetch error:', err));
}

// Run on page load
document.addEventListener('DOMContentLoaded', updateCartCount);

// Update after add to cart
const addToCartBtn = document.getElementById('AddToCart--product-template');

if (addToCartBtn) {
  addToCartBtn.addEventListener('click', () => {
    setTimeout(updateCartCount, 1500); // small delay for Shopify cart update
  });
}

const close_drawer__btn = document.querySelectorAll('.drawer__close .drawer__close-button.js-drawer-close');

if(close_drawer__btn.length > 0){
    close_drawer__btn.forEach((btn) => {
        btn.addEventListener('click', () => {
            window.location.reload();
        })
    })
}
/*** CART COUNT UPDATE END ***/